/** @deprecated */
export const petriSpecs = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  UseLineItemDiscountInCartSummary: 'specs.ecom.UseLineItemDiscountInCartSummary',
  CheckoutComposerSideCartSettingsPanelEntry: 'specs.ecom.CheckoutComposerSideCartSettingsPanelEntry',
  CheckoutComposerSuccessPopupSettingsPanelEntry: 'specs.ecom.CheckoutComposerSuccessPopupSettingsPanelEntry',
} as const;

export const conductorSpecs = {
  ecomCartLineItemUpsells: 'ecomCartLineItemUpsells',
  ecomPlanAndBookInPurchaseFlow: 'ecomPlanAndBookInPurchaseFlow',
  ecomIgnoreCartButtonsTextOpacity: 'ecomIgnoreCartButtonsTextOpacity',
  ecomCartCrossSell: 'ecomCartCrossSell',
  ecomCrossSellStoresItemSelection: 'ecomCrossSellStoresItemSelection',
  ecomSupportTestOrderOnCheckoutPage: 'ecomSupportTestOrderOnCheckoutPage',
  ecomShowSubtotalForNonCouponDiscounts: 'ecomShowSubtotalForNonCouponDiscounts',
  ecomScrollableSettingsPanelTabs: 'ecomScrollableSettingsPanelTabs',
  ecomEstimateCartOnAutomaticDiscountsIndicator: 'ecomEstimateCartOnAutomaticDiscountsIndicator',
  ecomDisplayBundles: 'ecomDisplayBundles',
} as const;

export const SPECS = {
  ...petriSpecs,
  ...conductorSpecs,
} as const;
